
// import ImageDefault from '@/assets/images/image-product-deafult-Large.jpg'
export default {
  name: 'CheckoutDeliveryItems',
  components: {
    modalShippingItems: async () =>
      await import('@/components/delivery-charge/modalShippingItems.vue'),
  },
  props: {
    productGroups: {
      type: Array,
      default: Array,
    },
    items: {
      type: Array,
      default: () => {
        return [{}]
      },
    },
    complete: { type: Boolean, default: false },
    isUseCoupons: { type: Boolean, default: false },
    isDisabledBtnCoupon: { type: Boolean, default: false },
  },
  data() {
    return {
      groups: [],
      showShippingModal: false,
      shippingObj: {},
    }
  },
  watch: {
    productGroups: {
      handler: function () {
        this.groups = this.productGroups
      },
      deep: true,
    },
  },
  mounted() {
    this.groups = this.productGroups
    // var value = this.items
    // value = value.reduce((h, value) => {
    //   return Object.assign(h, {
    //     [value.soldBy]: (h[value.soldBy] || []).concat(value),
    //   })
    // }, {})
    // Object.keys(value).forEach((element) => {
    //   this.groups.push({
    //     soldBy: element,
    //     FulfilledBy: value[element][0].FulfilledBy,
    //     items: value[element],
    //   })
    // })
    // console.log(this.groups)
    console.log('productGroups', this.groups)
  },
  methods: {
    displayProductImage(product) {
      // let img = productImageList.images
      // let isImgErr = false

      // if (img.length) {
      //   const imgCheck = new Image()
      //   imgCheck.onerror = function () {
      //     isImgErr = true
      //   }
      //   imgCheck.src = img.find((q) => q.size === 'thumbnail').url
      // }

      // let errImg =
      //   'https://ofm-cdn0.ofm.co.th/images/image-product-default-thumbnail.jpg'
      let timeStamp = this.$utils.isObjectKeyValid(
        product.update_info,
        'timestamp'
      )
        ? ''
        : ''

      // if (img.length && !isImgErr) {
      //   return img.some((q) => q.size === 'thumbnail')
      //     ? img.find((q) => q.size === 'thumbnail').url + timeStamp
      //     : errImg
      // } else {
      //   return errImg
      // }

      return `https://pim-cdn0.ofm.co.th/products/original/${product.sku_code}.jpg?x-image-process=image/format,webp/resize,w_90,h_90${timeStamp}`
    },
    imgError($event) {
      $event.target.src =
        'https://ofm-cdn0.ofm.co.th/images/image-product-default-thumbnail.jpg'
      $event.target.srcset = this.$utils.genImgSrcSet(
        'https://ofm-cdn0.ofm.co.th/images/image-product-default-thumbnail.jpg',
        [
          { w: 115, h: 115, q: 90, ws: '115w' },
          { w: 150, h: 150, q: 90, ws: '150w' },
        ]
      )
    },
    onFilterWarning(group, key) {
      console.log('warning_messages', group)
      return group?.warning_messages?.filter((msg) => msg.key === key)[0]
    },
  },
}
